<h2 mat-dialog-title>Match Loan Account</h2>
<mat-dialog-content>
	<p class="dialog-hint">Correct the banking details below and validate to find the matching loan account.</p>

	<form [formGroup]="form" class="edit-form">
		<div class="field-row">
			<mat-form-field appearance="outline" class="field-institution">
				<mat-label>Institution Code</mat-label>
				<input matInput formControlName="institutionCode" placeholder="e.g. 001" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="field-transit">
				<mat-label>Transit Number</mat-label>
				<input matInput formControlName="transitNumber" placeholder="e.g. 00010" />
			</mat-form-field>
		</div>
		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Account Number</mat-label>
			<input matInput formControlName="accountNumber" />
		</mat-form-field>
		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Recipient Name</mat-label>
			<input matInput formControlName="recipientName" />
		</mat-form-field>
	</form>

	<!-- Loan account resolved and chargeable -->
	<div *ngIf="canApply" class="match-result success">
		<mat-icon>check_circle</mat-icon>
		<div>
			<div class="match-label">Loan account matched</div>
			<div class="match-detail">Loan #{{ accountMatch.loanNumber }}</div>
			<div class="match-detail" *ngIf="accountMatch.customerName">{{ accountMatch.customerName }}</div>
		</div>
	</div>
	<!-- Loan matched but already paid off -->
	<div *ngIf="loanPaidOff" class="match-result warn">
		<mat-icon>report_problem</mat-icon>
		<div>
			<div class="match-label">Loan is paid off</div>
			<div class="match-detail">Loan #{{ accountMatch?.loanNumber }}<span *ngIf="accountMatch?.customerName"> — {{ accountMatch?.customerName }}</span> is already paid off, so no payment is due.</div>
		</div>
	</div>
	<!-- Loan matched but still not chargeable (e.g. customer data missing in NLS) -->
	<div *ngIf="unresolvedAfterMatch" class="match-result warn">
		<mat-icon>report_problem</mat-icon>
		<div>
			<div class="match-label">Loan account matched, but cannot be charged</div>
			<div class="match-detail">Loan #{{ accountMatch?.loanNumber }}<span *ngIf="accountMatch?.customerName"> — {{ accountMatch?.customerName }}</span></div>
			<div class="match-detail">{{ unresolvedReason }}</div>
		</div>
	</div>
	<!-- No loan account resolved from the bank details -->
	<div *ngIf="accountNotMatched" class="match-result no-match">
		<mat-icon>cancel</mat-icon>
		<span>No matching loan account found. Please check the institution, transit and account number.</span>
	</div>
	<div *ngIf="validateError" class="match-result error">
		<mat-icon>error_outline</mat-icon>
		<span>{{ validateError }}</span>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-stroked-button (click)="onCancel()" type="button" [disabled]="isValidating">Cancel</button>
	<button mat-stroked-button (click)="onValidate()" type="button"
		[disabled]="form.invalid || isValidating">
		<mat-spinner *ngIf="isValidating" diameter="16" class="btn-spinner"></mat-spinner>
		<span>Validate</span>
	</button>
	<button mat-raised-button color="primary" (click)="onApply()" type="button"
		[disabled]="!canApply">
		Apply
	</button>
</mat-dialog-actions>